import { BRAND } from "../../types";

interface OrderFooterProps {
  ready: boolean;
  loading?: boolean;
  onSubmit: () => void | Promise<void>;
}

export function OrderFooter({
  ready,
  loading,
  onSubmit,
}: OrderFooterProps) {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-white z-40"
      style={{ borderTop: "1px solid #F5F5F5", paddingTop: "16px", paddingBottom: "calc(16px + env(safe-area-inset-bottom, 0px))" }}
    >
      <div className="px-4 pt-4">
        <button
          onClick={onSubmit}
          disabled={!ready || loading}
          className="w-full py-3.5 rounded-2xl text-sm font-bold cursor-pointer active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          style={{
            background: ready
              ? `linear-gradient(135deg, ${BRAND}, #FF9A5C)`
              : "#E5E7EB",
            color: ready ? "#fff" : "#9CA3AF",
          }}
        >
          {loading ? "处理中..." : (ready ? "确认并支付" : "请先完善出行信息")}
        </button>
      </div>
    </div>
  );
}
